import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "@/context/SettingsContext";

const setMeta = (sel, attrs) => { let el = document.head.querySelector(sel); if (!el) { el = document.createElement(sel.startsWith("link") ? "link" : "meta"); Object.entries(attrs.key).forEach(([k, v]) => el.setAttribute(k, v)); document.head.appendChild(el); } Object.entries(attrs.set).forEach(([k, v]) => el.setAttribute(k, v)); };

export function useSeo(title, description, { noindex = false } = {}) {
  const { settings } = useSettings();
  const { pathname } = useLocation();
  useEffect(() => {
    const brand = settings?.business_name || "Kaur Cleaning Services";
    const full = title ? `${title} | ${brand}` : brand;
    const desc = description || settings?.tagline || "";
    const url = `${window.location.origin}${pathname}`;
    document.title = full;
    setMeta('meta[name="description"]', { key: { name: "description" }, set: { content: desc } });
    setMeta('meta[name="robots"]', { key: { name: "robots" }, set: { content: noindex ? "noindex, nofollow" : "index, follow" } });
    setMeta('link[rel="canonical"]', { key: { rel: "canonical" }, set: { href: url } });
    [["og:title", full], ["og:description", desc], ["og:url", url], ["og:type", "website"], ["og:site_name", brand], ["og:locale", "en_CA"]].forEach(([p, c]) => setMeta(`meta[property="${p}"]`, { key: { property: p }, set: { content: c } }));
    [["twitter:card", "summary_large_image"], ["twitter:title", full], ["twitter:description", desc]].forEach(([n, c]) => setMeta(`meta[name="${n}"]`, { key: { name: n }, set: { content: c } }));
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [title, description, settings, pathname, noindex]);
}

export function useJsonLd(id, data) {
  useEffect(() => {
    if (!data) return;
    let el = document.getElementById(id);
    if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = id; document.head.appendChild(el); }
    el.textContent = JSON.stringify(data);
    return () => { el?.remove(); };
  }, [id, JSON.stringify(data)]); // eslint-disable-line react-hooks/exhaustive-deps
}
